// カードを新規追加するモーダルのコンポーネント

import React, { useState } from 'react';

import './ImageModal.css';

// React Modalで実装
import Modal from 'react-modal';

const ImageModal = ({modalIsOpen, closeModal, link, customClass}) => {
    
    return (
        <>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="image-modal"
                overlayClassName="image-modal-overlay"
                contentLabel="Image Modal"
            >
                <img className={customClass} src={link} />
            </Modal>
        </>
    );
}

export default ImageModal;